import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { refreshProductList, closeProductModal } from "../../../redux/features/productModalSlice";

import {
  UpdateSubCategory,
} from "../../../redux/services/subCategoriesService/subCategories.Services";

import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";

import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

import {
  closeModal, refreshList
} from "../../../redux/features/modalSlice";

function EditSubCategory({ data, onSuccess }) {
  const dispatch = useDispatch();
const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
const [errors, setErrors] = useState({});
 const [formData, setFormData] = useState({
  category_id: "",
  name: "",
  status: true,
});

useEffect(() => {
  if (data) {
    setFormData({
      category_id: data.category_id || "",
      name: data.name || "",
      status: data.status === 1 || data.status === true,
    });
  }
}, [data]);
  
    useEffect(() => {
      fetchCategories();
    }, []);
  
    const fetchCategories = async () => {
      try {
        const res = await ActiveCategoryList();
  
        if (res?.success) {
          setCategories(res.data || []);
        
        }
      } catch (error) {
        console.log(error);
        errorToast("Something went wrong");
      }
    };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status"
          ? value === "Active"
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const payload = {
        id: data?.id,
          category_id: formData.category_id,
        name: formData.name,
        status: formData.status ? 1 : 0,
      };

      const res = await UpdateSubCategory(payload);
      if (res.success === true) {
        successToast(res.message);
        dispatch(closeProductModal())
        dispatch(refreshProductList())
      } else {
        errorToast(res.message);
      }



    } catch (err) {
      console.log(err);

      errorToast(
        err?.message ||
        "Error updating role"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form
        onSubmit={handleSubmit}
        className="row "
      >

         <div className="mb-3">
        <label className="form-label">
          Select Category
        </label>
        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
           className={`form-control ${errors?.category_id ? "is-invalid" : ""}`}
        >
          <option value="">
            Select Category
          </option>
          {categories?.map((item) => (
            <option
              key={item.id}
              value={item.id}
            >
              {item.name}
            </option>
          ))}
        </select>
        {errors?.category_id && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.category_id) ? errors.category_id[0] : errors.category_id}
          </div>
        )}
      </div>

      {/* Sub Category */}

      <div className="mb-3">
        <label className="form-label">
          Sub Category Name
        </label>

        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
              className={`form-control ${errors?.name ? "is-invalid" : ""}`}

        />

       {errors?.name && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors.name) ? errors.name[0] : errors.name}
          </div>
        )}
      </div>

        <div className="col-md-12">
          <label>Status</label>

          <select
            name="status"
            value={
              formData.status
                ? "Active"
                : "Inactive"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>

        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary"
          >
            {isLoading
              ? "Updating..."
              : "Update SubCategory"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default EditSubCategory;